import { createApp } from 'vue'// 核心依赖：创建Vue应用实例
import App from './App.vue'// 根组件：应用入口组件
import router from './router'// 路由配置：管理页面跳转/路由规则
import request from '@/util/request'// 网络请求：封装后的Axios实例（全局可用）

import ElementPlus from 'element-plus'// UI组件库：Element Plus核心（含组件/指令）
import 'element-plus/dist/index.css'// Element Plus 自带的全局样式
import * as ElementPlusIconsVue from '@element-plus/icons-vue'// 图标组件：Element Plus所有图标（全局注册）
import zhCn from 'element-plus/es/locale/lang/zh-cn'// 语言包：Element Plus中文国际化配置 使组件内置的文本显示为中文，比如内置按钮，不设置可能显示为英文
import dayjs from 'dayjs' // element-plus 的时间格式化处理库

import { ValidConst,IconList } from '@/util/validConst'// 验证常量：全局正则/验证规则（如手机号、邮箱正则）
import { GlobalContextPlugin } from '@/util/globalContext';//挂载封装的  $request router 保留了手动，减少代码量，保留 手动取值挂载
import CommonList from '@/util/vueutil/CommonList.vue' // 全局注册列表页组件

// 创建Vue应用实例（以App为根组件）
const app = createApp(App)

// 全局注册Element Plus所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 全局注册Element Plus（含中文语言包）
app.use(ElementPlus, { locale: zhCn })
// 全局注册路由功能
app.use(router)
app.use(GlobalContextPlugin);
app.component('CommonList', CommonList)
// 全局挂载：网络请求（this.$request）
app.config.globalProperties.$request = request
// 全局挂载：验证常量（this.$ValidConst）
app.config.globalProperties.$ValidConst = ValidConst
app.config.globalProperties.$IconList = IconList
app.config.globalProperties.$dayjs = dayjs
// 1. 基础时间格式化 也可 传 YYYY-MM-DD
app.config.globalProperties.$formatTime = (time, format = 'YYYY-MM-DD HH:mm:ss') => {
    if (!time) return ''  // 空值兜底返回空字符串（避免渲染undefined）
    return dayjs(time).format(format)
}

// 2. 中文格式时间（如：2026年2月11日）
app.config.globalProperties.$formatTimeCn = (time) => {
    if (!time) return ''
    // MMMM会显示完整月份（中文），D显示日期（不带前导零）
    return dayjs(time).format('YYYY年M月D日')
    // 如需补零（2026年02月11日），改用：'YYYY年MM月DD日'
}

// 3. 金额格式化（保留2位小数，千分位分隔，如：12345.67 → 12,345.67）
app.config.globalProperties.$formatMoney = (amount) => {
    if (amount === null || amount === undefined || isNaN(amount)) return '0.00'

    // 先转数字并保留2位小数，再处理千分位
    const num = Number(amount).toFixed(2)
    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 4. 小数格式化（自定义保留位数，默认2位，可选是否四舍五入）
app.config.globalProperties.$formatDecimal = (num, digits = 2, round = true) => {
    if (num === null || num === undefined || isNaN(num)) return '0.' + '0'.repeat(digits)

    const number = Number(num)
    if (round) {
        // 四舍五入保留指定位数
        return number.toFixed(digits)
    } else {
        // 不四舍五入，直接截取指定位数（如：1.239 → 1.23）
        const multiplier = Math.pow(10, digits)
        return (Math.floor(number * multiplier) / multiplier).toFixed(digits)
    }
}
// 挂载应用到DOM（id为app的容器，需放在所有配置最后）
app.mount('#app')